export default function MvpEntregaveis() {
  return (
    <section id="entregaveis" className="py-20 bg-stone-50">
      <div className="max-w-5xl mx-auto px-6 lg:px-10">
        <div className="flex items-center gap-3 mb-3">
          <div className="w-8 h-8 rounded-lg bg-[#071210] flex items-center justify-center">
            <span className="text-emerald-400 text-xs font-bold">VII</span>
          </div>
          <span className="text-stone-400 text-xs uppercase tracking-widest font-medium">Parte VII</span>
        </div>
        <h2 className="text-3xl font-bold text-stone-900 mb-2">Entregáveis — Fase 1</h2>
        <p className="text-stone-500 mb-10 text-base">O que está incluído na Versão 1 e o que está fora do escopo desta proposta.</p>

        {/* Entregáveis por marco */}
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mb-10">
          {[
            {
              marco: 'Dia 0 — Início',
              badge: 'bg-emerald-100 text-emerald-700',
              items: [
                'Contrato assinado e ambiente de desenvolvimento configurado',
                'Repositório Git criado e transferido ao cliente',
                'Documento de arquitetura técnica aprovado',
                'Cronograma de sprints e marcos de entrega definidos',
              ],
            },
            {
              marco: 'Dia 60 — Meio',
              badge: 'bg-amber-100 text-amber-700',
              items: [
                'Módulo 1 (Coletor de Editais) em produção e coletando',
                'Módulo 2 (Agente Analisador) gerando análises estruturadas',
                'Módulo 3 (Portfólio e Matching) com pontuação funcionando',
                'Módulo 4 (Dashboard e Gestão) com pipeline Kanban ativo',
                'Relatório de progresso e demonstração ao cliente',
              ],
            },
            {
              marco: 'Dia 120 — Entrega Final',
              badge: 'bg-stone-200 text-stone-700',
              items: [
                'Módulo 5 (Base de Conhecimento) indexada e operacional',
                'Módulo 6 (Agente Escritor) gerando propostas completas',
                'Módulo 7 (Exportação e Conformidade) com checklist ativo',
                'Módulo 8 (Editor e Monitoramento) integrado à plataforma',
                'Testes finais concluídos com cobertura acima de 80%',
                'Deploy em produção no domínio do instituto',
                'Treinamento da equipe e manual do gestor entregue',
                'Suporte intensivo de 30 dias pós-go-live incluído',
              ],
            },
          ].map((m) => (
            <div key={m.marco} className="rounded-xl border border-stone-200 bg-white overflow-hidden">
              <div className="bg-stone-900 px-4 py-3">
                <span className={`inline-block px-2.5 py-0.5 rounded-full text-xs font-semibold ${m.badge}`}>{m.marco}</span>
              </div>
              <ul className="p-4 space-y-2">
                {m.items.map((item, i) => (
                  <li key={i} className="flex items-start gap-2">
                    <div className="w-4 h-4 mt-0.5 rounded-full bg-emerald-100 flex items-center justify-center flex-shrink-0">
                      <i className="ri-check-line text-emerald-600 text-xs w-3 h-3 flex items-center justify-center"></i>
                    </div>
                    <span className="text-stone-600 text-xs leading-relaxed">{item}</span>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* Documentação e transferência */}
        <div className="p-6 rounded-2xl border border-stone-200 bg-white mb-8">
          <h3 className="text-base font-semibold text-stone-800 mb-4">Documentação e Transferência de Conhecimento</h3>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
            {[
              { icon: 'ri-git-repository-line', label: 'Código-fonte completo', desc: 'Repositório Git transferido ao cliente com histórico completo de commits' },
              { icon: 'ri-file-code-line', label: 'Documentação técnica', desc: 'Arquitetura, endpoints da API, guia de manutenção e decisões de design' },
              { icon: 'ri-book-2-line', label: 'Manual do gestor', desc: 'Guia de uso em linguagem não técnica para a equipe do instituto' },
              { icon: 'ri-shield-check-line', label: 'Relatório de testes', desc: 'Cobertura automatizada acima de 80% com relatório de qualidade' },
              { icon: 'ri-team-line', label: 'Treinamento presencial', desc: 'Sessão de treinamento com a equipe que vai operar a plataforma' },
              { icon: 'ri-customer-service-2-line', label: 'Suporte pós-entrega', desc: '30 dias de suporte intensivo após o go-live sem custo adicional' },
            ].map((d) => (
              <div key={d.label} className="flex items-start gap-3 p-3 rounded-lg bg-stone-50 border border-stone-200">
                <div className="w-8 h-8 rounded-lg bg-white border border-stone-200 flex items-center justify-center flex-shrink-0">
                  <i className={`${d.icon} text-stone-600 text-sm w-4 h-4 flex items-center justify-center`}></i>
                </div>
                <div>
                  <p className="text-stone-700 text-xs font-semibold">{d.label}</p>
                  <p className="text-stone-400 text-xs leading-relaxed">{d.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Fora do escopo */}
        <div className="p-6 rounded-2xl border border-stone-200 bg-white mb-8">
          <h3 className="text-base font-semibold text-stone-800 mb-4 flex items-center gap-2">
            <i className="ri-information-line text-stone-500 text-sm w-4 h-4 flex items-center justify-center"></i>
            Fora do Escopo desta Proposta
          </h3>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
            {[
              { item: 'Integração com ERP ou SIAPEX', note: 'Módulo adicional orçado separadamente' },
              { item: 'Submissão automática via API no portal Finep', note: 'A FINEP não disponibiliza API pública para submissão' },
              { item: 'Aplicativo móvel (Android ou iOS)', note: 'Previsto para backlog futuro após estabilização da plataforma' },
              { item: 'Monitoramento de fontes além da FINEP', note: 'O escopo desta proposta cobre 100% das chamadas FINEP' },
              { item: 'Chat conversacional com o edital', note: 'Funcionalidade prevista na Versão 2, fora do escopo da Fase 1' },
              { item: 'Analytics estratégico e relatórios executivos', note: 'Funcionalidades previstas na Versão 2, fora do escopo da Fase 1' },
            ].map((s) => (
              <div key={s.item} className="flex items-start gap-3 p-3 rounded-lg bg-stone-50 border border-stone-200">
                <div className="w-5 h-5 rounded-full bg-stone-200 flex items-center justify-center flex-shrink-0 mt-0.5">
                  <i className="ri-close-line text-stone-500 text-xs w-3 h-3 flex items-center justify-center"></i>
                </div>
                <div>
                  <p className="text-stone-700 text-xs font-semibold">{s.item}</p>
                  <p className="text-stone-400 text-xs">{s.note}</p>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Próximo passo: Versão 2 */}
        <div className="p-6 rounded-2xl border border-stone-200 bg-stone-900">
          <div className="flex items-start gap-4">
            <div className="w-10 h-10 rounded-xl bg-stone-700 flex items-center justify-center flex-shrink-0">
              <i className="ri-rocket-2-line text-stone-300 text-base w-5 h-5 flex items-center justify-center"></i>
            </div>
            <div>
              <h3 className="text-white font-semibold text-base mb-2">E depois da Fase 1? A Versão 2 está disponível.</h3>
              <p className="text-stone-400 text-sm mb-4 leading-relaxed">
                Após validar o ciclo completo com a Fase 1, o instituto pode contratar a Versão 2 para adicionar inteligência estratégica: chat com o edital, analytics avançado de captação e relatórios executivos automáticos.
              </p>
              <div className="grid grid-cols-1 sm:grid-cols-3 gap-3">
                {[
                  { icon: 'ri-chat-3-line', label: 'Chat com o Edital', desc: 'Tire dúvidas sobre qualquer edital em linguagem natural' },
                  { icon: 'ri-bar-chart-2-line', label: 'Analytics Estratégico', desc: 'Pipeline de captação com projeções e análise de oportunidades perdidas' },
                  { icon: 'ri-file-chart-line', label: 'Relatórios Executivos', desc: 'Relatórios mensais automáticos para a diretoria do instituto' },
                ].map((f) => (
                  <div key={f.label} className="p-3 rounded-lg bg-stone-800 border border-stone-700">
                    <div className="flex items-center gap-2 mb-1.5">
                      <i className={`${f.icon} text-stone-400 text-sm w-4 h-4 flex items-center justify-center`}></i>
                      <span className="text-stone-300 text-xs font-semibold">{f.label}</span>
                    </div>
                    <p className="text-stone-500 text-xs leading-relaxed">{f.desc}</p>
                  </div>
                ))}
              </div>
              <p className="text-stone-500 text-xs mt-3">Versão 2: orçada separadamente após a entrega e validação da Fase 1.</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
